import { API } from 'aws-amplify';
import { API_NAME } from './maricoApi';
import AppLogger from 'utils/AppLogger';
import { getErrorResult } from 'models/error';

/**
 * QSReportの埋め込みURLを取得する。
 * @param shipId 船舶ID
 * @return 埋め込みURL
 */
export async function getQSReportUrlAsync(shipId: string): Promise<string> {
  try {
    const params = {
      headers: {},
      response: true,
    };
    const result = await API.get(API_NAME, '/v1/qs-report/url?shipId=' + shipId, params);

    return result.data.url;
  } catch (error) {
    AppLogger.error('error getQSReportUrlAsync: ', error);
    throw getErrorResult(error);
  }
}
